module.exports = __webpack_public_path__ + "static/media/Background2.6b9d5d8c.jpg";